import { FilterTag as AntdFilterTag } from "@empglabs/backoffice-ui-kit"

const FilterTag = props => {
  return <AntdFilterTag {...props} />
}

export default FilterTag
